import * as React from 'react';
import { capitalize } from 'lodash';

import Link from 'components/Link';
import Text from 'components/Text';
import Row from 'components/Row';
import Icon from 'components/IconDeprecated';

import './DeliveryModalSection.scss';

import { SocialMediaCrossPostingDetails_api_postSummariesByMessage_socialMediaPosts as RowData } from 'chat/components/DeliveryModal/DeliveryModalSection/queries/__generated__/SocialMediaCrossPostingDetails';

export type Props = {
  post: RowData;
  rowNumber: number;
};

function SocialMediaDeliveryModalSectionRow({ post, rowNumber }: Props) {
  const rowKey = `${post.platformDisplayName.replace(' ', '-')}-${rowNumber}`;
  return (
    <div className="DeliveryModalSection-social-media-item" key={rowKey + 'div'}>
      <Row className="DeliveryModalSection-social-media-item-post-row" size="xxxsmall" key={rowKey}>
        <Text size="xsmall">{post.platformDisplayName}</Text>
        {post.postLinkUrl ? (
          <Link data-test="social-media-post-link" target="_blank" href={post.postLinkUrl}>
            <Text size="xsmall" weight="semibold" color="mascot" capitalize>
              {post.platform}{' '}
            </Text>
            <Icon name="external-link" color="mascot" />
          </Link>
        ) : (
          <Text size="xsmall" weight="semibold" color="graphite" capitalize>
            {post.platform}
          </Text>
        )}
      </Row>
      {post.platformError && (
        <Row
          className="DeliveryModalSection-social-media-item-error-row"
          key={rowKey + '-error'}
          size="xxxsmall"
        >
          <Text data-test="social-media-post-error" size="xxsmall" color="apple">
            {'An error occurred: "'}
            {post.platformError}
            {'" '}
            {`To retry, please post directly to ${capitalize(post.platform)}.`}
          </Text>
        </Row>
      )}
    </div>
  );
}

export default SocialMediaDeliveryModalSectionRow;
